/* global axios */
import ApiClient from '../ApiClient';

// "Recently Shared" log for the Sales Projects Documents page — real
// events only (fired after a genuine wa.me/mailto/clipboard action
// succeeds), never fabricated. See Nexceo::ProjectDocumentShare.
class NexceoProjectDocumentSharesAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  get(projectId) {
    return axios.get(`${this.url}/${projectId}/document_shares`);
  }

  create(projectId, documentId, channel) {
    return axios.post(`${this.url}/${projectId}/document_shares`, {
      document_share: { document_id: documentId, channel },
    });
  }
}

export default new NexceoProjectDocumentSharesAPI();
